"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var callahanColors_1 = require("./callahanColors");
// Utility function that returns the hex color for a named color or the input string if no match is found
var getHexColor = function (namedColor) {
    var newColor = callahanColors_1.default[namedColor];
    if (newColor) {
        return getHexColor(newColor);
    }
    else {
        return namedColor;
    }
};
exports.default = getHexColor;
//# sourceMappingURL=getHexColor.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/callahan-react/es/services/getHexColor.js
// module id = 16
// module chunks = 0